import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Title} from '@angular/platform-browser';


@Component({
  standalone: false,
  selector: 'app-perform-transactions',
  templateUrl: './perform-transactions.component.html',
  styleUrls: ['./perform-transactions.component.scss']
})
export class PerformTransactionsComponent implements OnInit {
  subPage:string;
  constructor(private activeRouter: ActivatedRoute, private titleService: Title, private cdr: ChangeDetectorRef) {
  }

  containsError = false;
  transactionHeader: string;
  errorMsg: string;
  isLoanPayOff = false;
  isCalLoanPayOff = false;
  isunshedPageOff = false;
  isServiceTransfer = false;
  isPartPmnt = false;
  isLoanStatusMaintne = false;
  isPaymentChange = false;
  // menudivider = require('../../../../assets/images/EMBMenuDividr.gif').default;
  title = 'Transactions Menu';

  ngOnInit(): void {
    this.activeRouter.queryParams.subscribe(params => {
      this.subPage = params.subPage;
      this.isunshedPageOff = true;
    });

    this.titleService.setTitle(this.title);
    this.transactionHeader = 'Transactions Menu';
    if (this.subPage !== undefined) {
      this.transactionHeader = this.subPage;
    }
    this.displayTransactionBody(this.transactionHeader);
    sessionStorage.setItem('currentSubMenuOption', 'RMServicing');
    this.cdr.detectChanges();
  }

  reset() {
    this.isLoanPayOff = false;
    this.isCalLoanPayOff = false;
    this.isunshedPageOff = false;
    this.isPartPmnt = false;
    this.isServiceTransfer = false;
    this.isLoanStatusMaintne = false;
    this.isPaymentChange = false;
  }

  displayTransactionBody(transName: string) {
    this.reset();
    if (transName === 'calLoanPayOff') {
      this.transactionHeader = 'Calculate Loan Payoff';
      this.isCalLoanPayOff = true;
    } else if (transName === 'loanPayOff') {
      this.transactionHeader = 'Loan Payoff';
      this.isLoanPayOff = true;
    } else if (transName === 'Unscheduled') {
      this.transactionHeader = 'Unscheduled';
      this.isunshedPageOff = true;
    } else if (transName === 'partpayment') {
      this.transactionHeader = 'Partial Prepayment';
      this.isPartPmnt = true;
    } else if (transName === 'serviceTransfer') {
      this.transactionHeader = 'Servicer Transfer';
      this.isServiceTransfer = true;
    } else if (transName === 'loanStatusMaintne') {
      this.transactionHeader = 'Loan Status Maintenance';
      this.isLoanStatusMaintne = true;
    } else if (transName === 'paymentChange') {
      this.transactionHeader = 'Payment Change';
      this.isPaymentChange = true;
    }
  }

}
